import { render, staticRenderFns } from "./HeaderDefault.vue?vue&type=template&id=2f03af5c&scoped=true&"
import script from "./HeaderDefault.vue?vue&type=script&lang=js&"
export * from "./HeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDefault.vue?vue&type=style&index=0&id=2f03af5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03af5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f03af5c')) {
      api.createRecord('2f03af5c', component.options)
    } else {
      api.reload('2f03af5c', component.options)
    }
    module.hot.accept("./HeaderDefault.vue?vue&type=template&id=2f03af5c&scoped=true&", function () {
      api.rerender('2f03af5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/HeaderDefault.vue"
export default component.exports